var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cursor-pointer openbnt"},[_c('div',{staticClass:"text-center",style:(_vm.size)},[_vm._t("default",function(){return [_c('div',{staticClass:"text",style:(_vm.location)},[_vm._v(" "+_vm._s(_vm.title)+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }